import Deadline from "../deadline"

export interface ProgressDeadlineProps {
    deadline: string;
    isCompleted: boolean;
}


export default function ProgressDeadline({ deadline, isCompleted }: ProgressDeadlineProps) {

    const deadlineDate = new Deadline(new Date(deadline))

    const styles = {
        color: isCompleted ? '#BDBDBD' : deadlineDate.deadlineColor,
    }

    return (
        <>
            <div className="ProgressDialog-deadline" style={styles}>
                <h5 className="CommonGoal-date" title="วันครบกำหนด">{deadlineDate.deadline}</h5>
                {
                    !isCompleted && (
                        <div className="flex gap-dot25">
                            <img src={deadlineDate.srcIcon} alt="" />
                            <h5 className="CommonGoal-countdown">{deadlineDate.diffDaysText}</h5>
                        </div>
                    )
                }
            </div>
        </>
    )
}